<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>
    <div class="content-box">
      <div class="content-box-header">
        <h2>12. {{ $t('documents') }}</h2>
      </div>
      <div class="two-column-grid"></div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.warrantyQCellsAttachments"
      fieldName="warrantyQCellsAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.acceptanceProtocolCustomerSignatureAttachments"
      fieldName="acceptanceProtocolCustomerSignatureAttachments"
      :maxImages="4"
    >
    </AttachmentsPrintGrid>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
